import React, { FunctionComponent } from "react";
import ModalBlock from "./Modal.block";
import ModalProps from "./ModalProps.interface";
import styles from "./Modal.module.scss";
import { AnimatePresence, motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { CLOSE_ALL_OVERLAYS } from "layout/redux/overlay.actions";
import ScrollLock from "react-scrolllock";
import Anchor from "components/Anchor/Anchor";
import IconViewer from "components/IconViewer/IconViewer";
import combineClasses from "helpers/combine-classes";
import FocusTrap from "focus-trap-react";

const Modal: FunctionComponent<ModalProps> = (props) => {
    const dispatch = useDispatch();
    const modalOpen = useSelector(state => state.overlay.modalOpen);

    const handleCloseModal = () => {
        dispatch({ type: CLOSE_ALL_OVERLAYS });
    };

    const alignContentTop = props.stickyLink && props.stickyLink.length === 0 ? styles.align_top : undefined;

    return (
        <div>
            <FocusTrap active={modalOpen}>
                <div>
                    <ScrollLock>
                        <motion.div initial={{ x: "100%", opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 0.4, ease: "easeOut" }} className={combineClasses([styles.wrapper, alignContentTop])}>
                            {/* Close Button */}
                            <div className={styles.modal_header}>
                                <button className={styles.close_button} onClick={handleCloseModal}>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>

                            {/* Modal Blocks */}
                            {props.modal ? (
                                <div className={styles.content}>
                                    {props.modal?.map((blockContent, index) => {
                                        return (
                                            <ModalBlock key={blockContent?.contentUdi} {...blockContent} />
                                        );
                                    })}
                                </div>
                            ) : null}

                            {/* Sticky Link */}
                            {props.stickyLink && props.stickyLink.length > 0 ? (
                                <Anchor to={props.stickyLink[0].content.link} className={styles.sticky_link}>
                                    {props.stickyLink[0].content.label}
                                    <IconViewer className={styles.link_arrow} name="arrow-bottom-right" />
                                </Anchor>
                            ) : null}
                        </motion.div>
                    </ScrollLock>
                    <AnimatePresence>
                        {modalOpen && props.modal ? (
                            <motion.div onClick={handleCloseModal} initial={{ opacity: 0 }} animate={{ opacity: 0.7 }} exit={{ opacity: 0 }} className={styles.overlay} />
                        ) : null}
                    </AnimatePresence>
                </div>
            </FocusTrap>
        </div>
    );
};

export default Modal;